// Centralized brand assets. To swap brand assets app-wide, change here.
// IMPORTANT: default to a same-origin path (not the emergentagent CDN) so
// privacy-focused browsers (Brave Shields, Firefox strict, uBlock) don't
// block the logo as a third-party asset when the site is served from
// beyondballindia.com. The CDN fallback is preserved via env var for dev.
export const LOGO_URL =
  process.env.REACT_APP_LOGO_URL ||
  '/brand-logo-256.png';

export const BRAND_NAME = 'Beyond Ball India';
